import { Navigate, useParams } from "react-router-dom";

/**
 * Alte Adresse `/einkauf/:id/entwurf` auf die Akte umleiten (Modul 38).
 *
 * Die eigene Entwurfsseite ist entfallen — ihre beiden Faehigkeiten stecken jetzt dort, wo
 * sie hingehoeren: neue Bestellungen im Anlage-Assistenten, Positionen einer bestehenden
 * Bestellung im Dialog „Positionen hinzufügen" in der Akte selbst.
 *
 * Die Adresse bleibt trotzdem gueltig: sie steht in Lesezeichen, in alten Meldungen und in
 * Verlaeufen. Ein 404 waere eine Strafe fuer jemanden, der nichts falsch gemacht hat;
 * `replace` haelt zusaetzlich den Zurueck-Knopf sauber, damit niemand in einer Schleife
 * zwischen Umleitung und Ziel landet.
 */
export default function PurchaseDraftRedirect() {
  const { id } = useParams();
  return <Navigate to={id ? `/einkauf/${id}` : "/einkauf"} replace />;
}
